var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",staticClass:"trace-helper",attrs:{"removeOnClose":""},on:{"close":_vm.handleDestroy}},[_c('craft-visual',{attrs:{"image":_vm.image,"object-fit":"contain","sizes":"100vw","no-placeholder":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }